import React from 'react';
import { format, subDays } from 'date-fns';

function DateRangePicker({ from, to, onChange }) {
  const today = format(new Date(), 'yyyy-MM-dd');

  const presets = [
    { label: '7D', days: 7 },
    { label: '14D', days: 14 },
    { label: '30D', days: 30 },
    { label: '90D', days: 90 },
  ];

  const handlePreset = (days) => {
    onChange({
      from: format(subDays(new Date(), days), 'yyyy-MM-dd'),
      to: today,
    });
  };

  return (
    <div className="date-range">
      {presets.map(({ label, days }) => (
        <button key={label} className="btn btn-sm btn-secondary" onClick={() => handlePreset(days)}>
          {label}
        </button>
      ))}
      <input
        type="date"
        value={from || ''}
        onChange={(e) => onChange({ from: e.target.value, to })}
      />
      <span>to</span>
      <input
        type="date"
        value={to || ''}
        max={today}
        onChange={(e) => onChange({ from, to: e.target.value })}
      />
    </div>
  );
}

export default DateRangePicker;
